export default __webpack_public_path__ + "static/media/homepage_6.dbc22fce.png";